module.exports = "<svg viewBox=\"0 0 560 560\" xmlns=\"http://www.w3.org/2000/svg\"><title>facebook</title><path d=\"M338.755 152.395h61.875V61h-72.72v.33c-88.08 3.12-106.17 52.65-107.76 104.685h-.165v45.6H160v89.52h59.985V541h90.435V301.135h74.07l14.265-89.52H310.42v-27.54c0-17.55 11.67-31.68 28.335-31.68z\" fill=\"#2B4E98\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./src/icons/facebook.svg
// module id = 562
// module chunks = 0 1 2